import { ContactDetailsFormProps } from '@/src/components/common/forms/contactDetailsForm'
import { Customer } from '@/src/types/itinerary'
import { isFlyin } from '@/src/utils/generalUtils/isFlyin'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useGetSaveTravelerData } from '../../useLoadUserData'

export const useContactDetails = (customer: Customer) => {
    const { userData } = useGetSaveTravelerData()
    const defaultMobileCountryCode = isFlyin()? '966' :'971'// saudi arabia or uae
    const initialContactDetails: Customer = useMemo(() => {
        return {
            ...customer,
            email: customer.email || userData?.customer?.email || '',
            mobile: customer.mobile || '',
            mobileCountryCode: customer.mobileCountryCode || defaultMobileCountryCode
        }
    }, [customer, userData?.customer])

    const [contactDetails, setContactDetails] = useState<Customer>(initialContactDetails)

    const onChangeContactDetails: ContactDetailsFormProps['onChange'] = useCallback((key, value) => {
        const isString = typeof value === 'string'
        setContactDetails(prev => ({
            ...prev,
            [key]: isString ? value.trim() : value
        }))
    }, [])

    useEffect(() => {
        if (userData?.customer?.email && !contactDetails.email) {
            setContactDetails(prev => ({
                ...prev,
                email: userData?.customer?.email || ''
            }))
        }
    }, [userData?.customer])

    return {
        contactDetails,
        setContactDetails,
        onChangeContactDetails
    }
}
